import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import StoreContext from '../../../react-core-lib/components/app/store-context';

const PLAN_BADGE = {
    Free: { label: 'FREE', bg: '#FF669B' },
    Student: { label: 'STUDENT', bg: '#FF669B' },
    Professional: { label: 'PRO', bg: '#FF669B' },
    'Clinic-multiuser': { label: 'CLINIC', bg: '#FF669B' },
    Clinic: { label: 'CLINIC', bg: '#FF669B' },
};

const DashboardGreeting = observer(() => {
    const { userDataStore } = useContext(StoreContext);
    const firstName = userDataStore?.userData?.firstName || '';
    const accountType = userDataStore?.subscriptionData?.accountType || 'Free';
    const badge = PLAN_BADGE[accountType] || PLAN_BADGE.Free;

    return (
        <Box
            sx={{
                maxWidth: '1440px',
                margin: '0 auto',
                width: '100%',
                px: { xs: '20px', md: '40px' },
                pt: { xs: '20px', md: '32px' },
                pb: { xs: '16px', md: '24px' },
                boxSizing: 'border-box',
            }}
        >
            <Box display="flex" alignItems="center" gap="12px">
                <Typography
                    sx={{
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 600,
                        fontSize: { xs: '24px', md: '40px' },
                        lineHeight: { xs: '24px', md: '40px' },
                        letterSpacing: { xs: '-0.96px', md: '-1.6px' },
                        color: '#000453',
                    }}
                >
                    Hi, {firstName}
                </Typography>

                <Box
                    sx={{
                        background: badge.bg,
                        borderRadius: '201px',
                        px: { xs: '10px', md: '12px' },
                        py: { xs: '2px', md: '4px' },
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 500,
                        fontSize: { xs: '12px', md: '16px' },
                        lineHeight: { xs: '12px', md: '16px' },
                        letterSpacing: { xs: '-0.24px', md: '-0.324px' },
                        color: '#FFFFFF',
                        display: 'inline-flex',
                        alignItems: 'center',
                        textShadow: '0px 0px 10px rgba(35, 7, 88, 0.1)',
                    }}
                >
                    {badge.label}
                </Box>
            </Box>

            <Typography
                sx={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 400,
                    fontSize: '18px',
                    lineHeight: '18px',
                    letterSpacing: '-0.72px',
                    color: '#000453',
                    mt: '10px',
                }}
            >
                Welcome to your dashboard
            </Typography>
        </Box>
    );
});

export default DashboardGreeting;
